.wrap {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 26rem;
}

.hiddenLabel {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.icon {
  position: absolute;
  left: var(--space-3);
  color: var(--color-text-muted);
  pointer-events: none;
}

.input {
  width: 100%;
  height: var(--control-height-md);
  padding: 0 calc(var(--space-3) + 1.75rem) 0 calc(var(--space-3) + 1.625rem);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
  color: var(--color-text);
  font-size: var(--font-size-base);
}

.input::-webkit-search-cancel-button {
  appearance: none;
}

.input:focus-visible {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-soft);
  border-radius: var(--radius-md);
}

.clear {
  position: absolute;
  right: var(--space-2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  border-radius: var(--radius-full);
  background-color: var(--color-surface-2);
  color: var(--color-text-2);
}
